import { Box, Heading, Flex } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import ChainIndicators from 'ui/home/indicators/ChainIndicators';
import LatestBlocks from 'ui/home/LatestBlocks';
import LatestZkEvmL2Batches from 'ui/home/LatestZkEvmL2Batches';
import Stats from 'ui/home/Stats';
import Transactions from 'ui/home/Transactions';
import AdBanner from 'ui/shared/ad/AdBanner';
import ProfileMenuDesktop from 'ui/snippets/profileMenu/ProfileMenuDesktop';
import SearchBar from 'ui/snippets/searchBar/SearchBar';
import WalletMenuDesktop from 'ui/snippets/walletMenu/WalletMenuDesktop';

const rollupFeature = config.features.rollup;

const Home = () => {
  return (
    <Box as="main">
      <Stats/>
      {/* <ChainIndicators/> */}
      <Flex mt={ 150 } direction={{ base: 'column', lg: 'row' }} columnGap={ 12 } rowGap={ 8 }
      sx={{
        '@media screen and (min-width: 821px) and (max-width: 840px)': {
            marginTop: '50px',
            width: '100%',
            justifySelf: 'center',
        },
        '@media screen and (min-width: 841px) and (max-width: 999px)': {
            marginTop: '100px',
            width: '100%',
            justifySelf: 'center',
        },
        '@media screen and (min-width: 600px) and (max-width: 840px)': {
            marginTop: '100px',
            width: '100%',
            justifySelf: 'center',
        },
        '@media screen and (min-width: 414px) and (max-width: 767px)': {
            marginTop: '200px',
            width: '100%',
            justifySelf: 'center',
        },
        '@media screen and (min-width: 0px) and (max-width: 413px)': {
            marginTop: '200px',
            width: '100%',
            justifySelf: 'center',
        },
        // '@media screen and (min-width: 1020px)': {
        //     marginTop: '100px',
        // },
        // '@media screen and (min-width: 1440px)': {
        //     width: '80%',
        //     justifySelf: 'center',
        // },
      }}
      >
        { rollupFeature.isEnabled && rollupFeature.type === 'zkEvm' ? <LatestZkEvmL2Batches/> : <LatestBlocks/> }
        <Box flexGrow={ 1 }>
          <Transactions/>
        </Box>
      </Flex>
    </Box>
  );
};

export default Home;
